import {
  ProviderEvidenceTrainingType,
  SubSpecializations,
} from "../types/TypeSpecialist";
import { getTranslation } from "./getTranslation";

export const getTrainingTypeLabel = (
  trainingType?: ProviderEvidenceTrainingType
) => {
  switch (trainingType) {
    case "basic":
      return "Basic education";
    case "specialization":
      return "Specialization";
    case "continuing":
      return "Continuing education";
    default:
      return undefined;
  }
};

export const formatCertificateSubSpecializations = (
  subSpecializations?: SubSpecializations[]
) => {
  if (!subSpecializations?.length) return undefined;

  return subSpecializations
    .map(
      (subSpecialization) =>
        getTranslation(subSpecialization.labels, "en") ||
        subSpecialization.specialization ||
        subSpecialization._id
    )
    .filter(Boolean)
    .join(", ");
};
